import { Underline } from "@tiptap/extension-underline"

// Cp mod: Add an optional `color` attribute that sets the underline's
// text-decoration color (still rendered on a <u> element). Modeled on the base
// Highlight extension's "multicolor" feature, but always enabled.
export const CpUnderline = Underline.extend({
  addAttributes() {
    return {
      ...(this.parent?.() ?? {}),
      color: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("data-color") || element.style.textDecorationColor,
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {}
          }

          return {
            "data-color": attributes.color,
            style: `text-decoration-color: ${attributes.color}`,
          }
        },
      },
    }
  },
})
